import { connectedStore } from '../../store';
import selectors from '../selectors';

const getBlock = (blockId) => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getBlock(state, blockId);
};

export default getBlock;
